











































































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

import { ALForm } from '@/common/component.types';

import { ISystemError } from '@/models/error/error.types';
import { ITag, ITagData, Tag } from '@/models/configurator';
import { SystemError } from '@/models/error/error';
import { diffDeep, setErrorFromAxiosError } from '@/utils/helpers';

// components
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import AlDialog from '@/components/core/Dialog/ALDialog.vue';

export interface Options extends InstanceType<typeof Vue> {
  $refs: {
    form: ALForm;
  };
}

export default Vue.extend<Options>({
  functional: false
}).extend({
  name: 'QuestionTagFormDialog',

  components: {
    ErrorAlert,
    AlDialog
  },

  data() {
    return {
      dialog: false,
      tagFormValid: false,
      isEdit: false,

      isLoading: false,

      error: null as null | ISystemError,

      tagData: {} as ITagData,

      requiredRule: [(v: string) => !!v || 'Field is required']
    };
  },

  computed: {
    ...mapGetters({
      getTagById: 'configuratorQuestion/getTagById'
    })
  },

  methods: {
    ...mapActions({
      createTag: 'configuratorQuestion/createTag',
      updateTag: 'configuratorQuestion/updateTag'
    }),

    resetFormValidation(): void {
      if (this.$refs.form) {
        return this.$refs.form.resetValidation();
      }
    },

    validateForm(): boolean {
      let valid = false;
      if (this.$refs.form) {
        valid = this.$refs.form.validate();
      }
      return valid;
    },

    open(tag?: ITag) {
      this.tagData = tag ? new Tag(tag) : {};

      this.isEdit = !!tag?.id;
      this.clearErrors();
      this.dialog = true;

      this.resetFormValidation();
    },

    clearErrors(): void {
      this.error = null;
    },

    close() {
      this.dialog = false;
    },

    async saveTag(): Promise<void> {
      this.clearErrors();

      if (this.validateForm()) {
        let tagInstance: ITag | null = null;
        try {
          tagInstance = new Tag(this.tagData);
        } catch (error) {
          if (SystemError.isSystemError(error)) {
            this.error = error;
          }
        }

        if (tagInstance != null) {
          this.isLoading = true;
          const payloadDelta = this.isEdit
            ? diffDeep(this.tagData, this.getTagById(this.tagData.id), true)
            : this.tagData;
          const saveAction = this.isEdit ? this.updateTag : this.createTag;

          saveAction(payloadDelta)
            .catch(error => {
              this.error = setErrorFromAxiosError(error);
            })
            .then(() => this.close())
            .finally(() => {
              this.isLoading = false;
            });
        }
      }
    }
  }
});
